import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, AppBar, Toolbar, Typography, Select, MenuItem, IconButton } from '@mui/material'
import { type SelectChangeEvent } from '@mui/material/Select'
import LogoutIcon from '@mui/icons-material/Logout'
import { useDispatch } from 'react-redux'

import { setIsAuthenticated } from '@store/slices/Authentication.slice'
import { getWithExpiry } from '@util/LocalStorage'

import { getFullName } from '@util/CommonServicess'
import { languageData } from '@config/Constants'
import classes from './AppHeader.module.css'

interface AppHeaderProps {
    isAuthenticated?: boolean
}

const selectCustomStyle = {
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(228, 219, 233, 0.25)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(228, 219, 233, 0.25)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(228, 219, 233, 0.25)',
    },
    '.MuiSvgIcon-root ': {
        fill: 'white !important',
    },
}

const AppHeader: React.FC<AppHeaderProps> = () => {
    const { t, i18n } = useTranslation()
    const [age, setAge] = React.useState('EN')
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const isAuthenticated = !!getWithExpiry('token')

    const handleChange = (event: SelectChangeEvent): void => {
        setAge(event.target.value)
        const langValue = event.target.value

        const selectedLanguage = languageData.find((item) => item.value === langValue)
        if (selectedLanguage) {
            void i18n.changeLanguage(selectedLanguage.code).then(() => {})
        }
    }

    const handleLogout = (): void => {
        localStorage.removeItem('token')
        dispatch(setIsAuthenticated(false))
        navigate('/login', { replace: true })
    }

    const generateNameLabel = (): string | null => {
        const name = getFullName()
        return name ? `- ${name}` : null
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed" className={classes.appbar}>
                <Toolbar className={classes.toolbar}>
                    <div className={classes.toolbarWrapper}>
                        <Typography className={classes.headerTypo}>
                            {t('header.dashboard')} {generateNameLabel()}
                        </Typography>

                        <div>
                            <Select
                                value={age}
                                onChange={handleChange}
                                renderValue={(value) => <div>{value}</div>}
                                color="secondary"
                                sx={{
                                    maxHeight: 35,
                                    color: 'white',
                                    ...selectCustomStyle,
                                }}
                            >
                                {languageData.map((lang, key) => (
                                    <MenuItem key={key} value={lang.value}>
                                        <Typography variant="body1" className={classes.menuTypo}>
                                            {lang.label}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                            {isAuthenticated && (
                                <IconButton color="secondary" className={classes.logoutButton} onClick={handleLogout}>
                                    <LogoutIcon />
                                </IconButton>
                            )}
                        </div>
                    </div>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default AppHeader
